export const DEFAULT_TOAST_TIMEOUT_MS = 10_000;
export const ERROR_TOAST_TIMEOUT_MS = 15_000;
export const MAX_TOASTS_COUNT = 5;
export const DEFAULT_TOAST_TITLE = '';